var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['news-item', { active: _vm.active }]},[_c('div',{staticClass:"preview",style:({
      'background-image': ("url(" + (_vm.cover ? _vm.cover : _vm.background) + ")")
    })},[_c('div',{staticClass:"overlay"},[_c('div',{staticClass:"play",style:({ 'background-image': ("url(" + _vm.playImage + ")") }),on:{"click":function($event){return _vm.$emit('read', _vm.id)}}})])]),_vm._v(" "),_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.titleText))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15ecf082","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/items/NewsEntity.vue
// module id = null
// module chunks = 